import React from 'react';
import './DestinationActivities.css';

function DestinationActivities({ destination }) {
  return (
    <section className="destination-activities-section">
      <div className="destination-activities-container">
        <h2 className="destination-activities-title">Activities & Experiences</h2>
        <p className="destination-activities-intro">
          Experience the best this destination has to offer with our curated activities.
        </p>
        
        <div className="activities-grid">
          {destination.activities.map((activity, index) => (
            <div key={index} className="activity-card">
              <div className="activity-icon-wrapper">
                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
                  <polyline points="22 4 12 14.01 9 11.01"/>
                </svg>
              </div>
              <h3 className="activity-name">{activity}</h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default DestinationActivities;

